import { api, handleApiError } from './api';

// This should ideally be sourced from a central config or the api module
const PYTHON_BACKEND_HOST = "https://staging.conversation.convrsespaces.com";

export interface ChatQuestionPayload {
  question: string;
  business_identifier: string;
  session_id?: string; // Optional: session ID from previous response to maintain conversation context
  conversation_ids?: string[]; // Optional: if not provided, searches all conversations for the business
  context_window?: number;
}

export interface ChatbotResponseData {
  answer: string;
  reasoning?: string;
  confidence?: string;
  total_matches?: number;
  session_id?: string; // Session ID returned from API to maintain conversation context
  // Potentially other fields from the API response
}

export interface ChatMessage {
  id: string; // For unique key in React lists
  type: 'user' | 'assistant';
  content: string | React.ReactNode;
  isLoading?: boolean;
}

class ChatService {
  async askChatbot(payload: ChatQuestionPayload): Promise<ChatbotResponseData> {
    try {
      const response = await api.post<any>( // Using 'any' for the direct response wrapper
        `${PYTHON_BACKEND_HOST}/chat/question`, 
        payload
      );
      // The actual chatbot response is in response.data.data
      if (response.data && response.data.data) {
        return response.data.data as ChatbotResponseData;
      }
      // If the structure is different, e.g. directly response.data
      // return response.data as ChatbotResponseData;
      
      // Fallback or error if structure is not as expected
      throw new Error("Unexpected API response structure");

    } catch (error) {
      return handleApiError(error);
    }
  }
}

export const chatService = new ChatService(); 